/**
 * Padrão de UUID no formato 8-4-4-4-12 (hexadecimal).
 *
 * Aceita qualquer versão de UUID de propósito — não valida o dígito de versão,
 * apenas o formato — para não rejeitar identificadores válidos gerados no back.
 *
 * Usado para restringir params de rota a UUIDs
 * (ex.: `/antecipacao/:anticipation(${UUID_PATTERN})`), evitando que valores
 * inválidos (ex.: "bloqueios") casem a rota e disparem chamadas à API com id
 * malformado — que retornam erro 500.
 */
export const UUID_PATTERN =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
